import { ssoOpenApiSpec } from './specs/ssoApiSpec';

/**
 * Swagger / OpenAPI spec configuration for the dashboard.
 * Add your API specs here. Each entry can be:
 * - url: URL to a JSON/YAML OpenAPI spec
 * - spec: Inline OpenAPI spec object
 *
 * @example
 * export const SWAGGER_API_SPECS: SwaggerApiSpec[] = [
 *   { name: 'My API', url: 'https://api.example.com/openapi.json' },
 *   { name: 'Internal API', spec: { openapi: '3.0.0', paths: { ... } } },
 * ];
 */
export interface SwaggerApiSpec {
  name: string;
  url?: string;
  spec?: Record<string, unknown>;
}

export const SWAGGER_API_SPECS: SwaggerApiSpec[] = [
  {
    name: 'SSO / Authentication APIs',
    spec: ssoOpenApiSpec as Record<string, unknown>,
  },
];
